import _defineProperty from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["signal"];
import _regeneratorRuntime from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e3) { throw _e3; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e4) { didErr = true; err = _e4; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useMemo as o, useRef as r, useCallback as n, useEffect as t, useState as e } from "react";
var s = function s() {
    return "undefined" != typeof window && "EyeDropper" in window;
  },
  c = function c() {
    return Promise.reject(new Error("Unsupported browser."));
  },
  i = function i() {
    var o = r(),
      _e = e(!1),
      _e2 = _slicedToArray(_e, 2),
      c = _e2[0],
      i = _e2[1];
    t(function () {
      return o.current = !0, i(s()), function () {
        o.current = !1;
      };
    }, []);
    var p = n(function () {
      return c;
    }, [c]);
    return [o, p];
  },
  p = function p(o) {
    var r = function (o) {
      return s() && new EyeDropper(o);
    }(o);
    var n;
    return (n = r) ? EyeDropper.prototype.open.bind(n) : c;
  },
  a = function a(e) {
    var s = o(function () {
        return p(e);
      }, [e]),
      _i = i(),
      _i2 = _slicedToArray(_i, 2),
      c = _i2[0],
      a = _i2[1],
      w = r(),
      d = n(function () {
        void 0 !== w.current && w.current.abort();
      }, [w]),
      f = n( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(o) {
          var _o, r, n, t, e;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                void 0 === o && (o = {}), d();
                _o = o, r = _o.signal, n = _objectWithoutProperties(_o, _excluded), t = new AbortController();
                w.current = t;
                e = void 0 !== r ? function (o) {
                  var r = new AbortController(),
                    n = function n() {
                      r.abort();
                      var _iterator = _createForOfIteratorHelper(o),
                        _step;
                      try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                          var _r = _step.value;
                          _r.removeEventListener("abort", n);
                        }
                      } catch (err) {
                        _iterator.e(err);
                      } finally {
                        _iterator.f();
                      }
                    };
                  var _iterator2 = _createForOfIteratorHelper(o),
                    _step2;
                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var _r2 = _step2.value;
                      if (_r2.aborted) {
                        n();
                        break;
                      }
                      _r2.addEventListener("abort", n);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                  return r.signal;
                }([r, t.signal]) : t.signal;
                _context.prev = 4;
                _context.next = 7;
                return s(_objectSpread(_objectSpread({}, n), {}, {
                  signal: e
                }));
              case 7:
                return _context.abrupt("return", _context.sent);
              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](4);
                throw c.current || (_context.t0.canceled = !0), _context.t0;
              case 13:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[4, 10]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), [w, c, d, s]);
    return t(function () {
      return d;
    }, [d]), {
      open: f,
      close: d,
      isSupported: a
    };
  };
export { a as default };